import { NgModule } from '@angular/core'

import { SharedModule } from '@@shared/shared.module'

import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component'
import { CompanyFinderComponent } from './company-finder/company-finder.component'
import { DynamicPageComponent } from './dynamic-page/dynamic-page.component'
import { NotfoundComponent } from './notfound/notfound.component'
import { ZohoSyncComponent } from './zoho-sync/zoho-sync.component'
import { TestComponent } from './test/test.component'
import { PublicLeadFormComponent } from './public-lead-form/public-lead-form.component'
import { LanguageSelectorComponent } from '../layout/language-selector/language-selector.component'

@NgModule({
    imports: [SharedModule, LanguageSelectorComponent],
    declarations: [
        ServiceUnavailableComponent,
        CompanyFinderComponent,
        DynamicPageComponent,
        NotfoundComponent,
        ZohoSyncComponent,
        TestComponent,
        PublicLeadFormComponent
    ]
})
export class PagesModal {}
